import { serializerNotRegistered1ovw7obgbxuzq as serializerNotRegistered } from './internal/Platform.common.mjs';
import { createThis2j2avj17cvnv2 as createThis } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { asList2ho2pewtsfvv as asList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { CONTEXTUAL_getInstance20l1ap7hne5we as CONTEXTUAL_getInstance } from './descriptors/SerialKinds.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor } from './descriptors/SerialDescriptors.mjs';
import { withContext3ge61vpog00ae as withContext } from './descriptors/ContextAware.mjs';
import { get_EMPTY_SERIALIZER_ARRAY2gyuhuf2kalz as get_EMPTY_SERIALIZER_ARRAY } from './internal/PluginHelperInterfaces.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from './KSerializer.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function serializer($this, serializersModule) {
  var tmp0_elvis_lhs = serializersModule.getContextual_lmiski_k$($this.serializableClass_1, $this.typeArgumentsSerializers_1);
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? $this.fallbackSerializer_1 : tmp0_elvis_lhs;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    serializerNotRegistered($this.serializableClass_1);
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
}
var ContextualSerializerClass;
function ContextualSerializer() {
  if (ContextualSerializerClass === VOID) {
    class $ {
      constructor(serializableClass, fallbackSerializer, typeArgumentsSerializers) {
        return new.target.new_kotlinx_serialization_ContextualSerializer_niymzz_k$(serializableClass, fallbackSerializer, typeArgumentsSerializers);
      }
      static new_kotlinx_serialization_ContextualSerializer_niymzz_k$(serializableClass, fallbackSerializer, typeArgumentsSerializers) {
        var $this = createThis(this);
        $this.serializableClass_1 = serializableClass;
        $this.fallbackSerializer_1 = fallbackSerializer;
        $this.typeArgumentsSerializers_1 = asList(typeArgumentsSerializers);
        var tmp = $this;
        var tmp_0 = CONTEXTUAL_getInstance();
        tmp.descriptor_1 = withContext(buildSerialDescriptor('kotlinx.serialization.ContextualSerializer', tmp_0, [], ($this$buildSerialDescriptor) => {
          var tmp = $this$buildSerialDescriptor;
          var tmp0_safe_receiver = $this.fallbackSerializer_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_descriptor_wjt6a0_k$();
          // Inline function 'kotlin.collections.orEmpty' call
          var tmp0_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_annotations_20dirp_k$();
          tmp.annotations_1 = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
          return Unit_instance;
        }), $this.serializableClass_1);
        return $this;
      }
      static new_kotlinx_serialization_ContextualSerializer_2v3fxc_k$(serializableClass) {
        return this.new_kotlinx_serialization_ContextualSerializer_niymzz_k$(serializableClass, null, get_EMPTY_SERIALIZER_ARRAY());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_kj9hv3_k$(encoder, value) {
        encoder.encodeSerializableValue_3uuzip_k$(serializer(this, encoder.get_serializersModule_piitvg_k$()), value);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_kj9hv3_k$(encoder, !(value == null) ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        return decoder.decodeSerializableValue_xpnpad_k$(serializer(this, decoder.get_serializersModule_piitvg_k$()));
      }
    }
    initMetadataForClass($, 'ContextualSerializer', VOID, VOID, [KSerializer()]);
    ContextualSerializerClass = $;
  }
  return ContextualSerializerClass;
}
//region block: exports
export {
  ContextualSerializer as ContextualSerializer1uidivg94sh5v,
};
//endregion

//# sourceMappingURL=ContextualSerializer.mjs.map
